module.exports = __webpack_public_path__ + "img/modulo-5.375fe196.svg";